import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import classnames from 'classnames';

import './masonryImage.css';

export const MasonryImage = ({link, url, slug, width, height, noFade}) => (
  <Link
    className={classnames('masonry-item', {'no-fade': noFade})}
    to={link}
    style={{paddingBottom: (height / width) * 100 + '%'}}
  >
    <img
      className="masonry-item-image"
      src={url}
      alt={slug}
      width={width}
      height={height}
    />
  </Link>
);

MasonryImage.displayName = 'MasonryImage';

MasonryImage.propTypes = {
  noFade: PropTypes.bool,
  link: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

MasonryImage.defaultProps = {
  noFade: false,
};



// WEBPACK FOOTER //
// ./src/components/masonryGallery/masonryImage/MasonryImage.js